import { render } from "./uploadResult.vue?vue&type=template&id=6f60f5c6&scoped=true"
import script from "./uploadResult.vue?vue&type=script&lang=js"
export * from "./uploadResult.vue?vue&type=script&lang=js"

import "./uploadResult.vue?vue&type=style&index=0&id=6f60f5c6&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f60f5c6"],['__file',"src/views/userCenter/userManage/components/uploadResult.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f60f5c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f60f5c6', __exports__)) {
    console.log('reload')
    api.reload('6f60f5c6', __exports__)
  }
  
  module.hot.accept("./uploadResult.vue?vue&type=template&id=6f60f5c6&scoped=true", () => {
    console.log('re-render')
    api.rerender('6f60f5c6', render)
  })

}


export default __exports__